import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";


const ProductCard = ({ product, handleAddToCart }) => {
  const {name,cost,rating,image,_id}=product;
  // const data = {
  //   "name":"Tan Leatherette Weekender Duffle",
  //   "category":"Fashion",
  //   "cost":150,
  //   "rating":4,
  //   "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
  //   "_id":"PmInA797xJhMIPti"
  //   }
  
  
  return (
    <Card className="card" >

        <CardMedia
          component="img"
          height="140"
          image={image}
          alt={name}
          sx={{height : "320px"}}
          className="productImg"
    
        />
        <CardContent>
          <Typography gutterBottom variant="h6">
          {name}
          </Typography>
          <Typography gutterBottom  sx={{ fontWeight: 'bold' }}>
            ${cost}
          </Typography>
          <Rating name="read-only" value={rating} readOnly />
          <Button variant="contained" sx={{width : "100%"}} value={_id} onClick={handleAddToCart}><AddShoppingCartOutlined /> &nbsp; ADD TO CART</Button>
        </CardContent>
    </Card>
  );
};

export default ProductCard;
